import React, {Fragment} from 'react';
import Collapsible from 'react-collapsible';
import CustomReactQuill from './CustomReactQuill';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import {collapsibleSettings} from '../../helpers/Helpers';
import InputWrap from "./InputWrap";

const WYSIWYGField = (props) => {
    const {input, omitCollapsible, label, expanded, meta: {touched, error}} = props;

    const inputWrapProps = {
        ...props,
    };

    const content = (
        <InputWrap {...inputWrapProps}>
            <CustomReactQuill
                name={input.name}
                value={input.value}
                {...input}
                onChange={(value) => {
                    input.onChange(value)
                }}
            />
            {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
        </InputWrap>
    );

    return (
        <Fragment>
            {omitCollapsible ? (
                <div>{content}</div>
            ) : (
                <Collapsible
                    {...collapsibleSettings}
                    trigger={label ? <label className={classNamesPrefixed({"trigger__label":true})}>{label}</label> : ''}
                    open={expanded}
                >
                    {content}
                </Collapsible>
            )}
        </Fragment>
    );
};

export default WYSIWYGField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/WYSIWYGField.js